import {
	StyledContainer,
	StyledName,
	StyledCount,
} from './SectionHeading.styled';

const SectionHeading = ({
	icon,
	name,
	itemNumber,
	itemMax,
	...props
}: {
	icon: string;
	name: string;
	itemNumber?: number;
	itemMax?: number;
} & React.HTMLAttributes<HTMLDivElement>) => {
	return (
		<StyledContainer {...props}>
			<img src={icon} />
			<StyledName>{name}</StyledName>
			{itemNumber !== undefined && (
				<StyledCount>
					{itemNumber} <span>/ {itemMax}</span>
				</StyledCount>
			)}
		</StyledContainer>
	);
};

export { SectionHeading };
